module.exports = __webpack_public_path__ + "img/napravlen-mnemo-mob.0ac3a7b3.jpg";